const isValid = (item, shopItems) => {
  const { conditions, appendTo } = item
  return conditions.length && appendTo.length && conditions.every(c => shopItems.find(i => i.id === c))
}

export { isValid }
